<template>
  <div id="page-onboarding" class="d-flex">
    <MainBarMenuV2 v-if="(user.core_role_id > 10 && user.core_role_id < 23)"/>
    <MainBarMenu v-if="user.core_role_id < 11 && user.core_role_id > 0"/>
    <OnboardingVP2 v-if="(user.core_role_id > 10 && user.core_role_id < 23)"/>
    <OnboardingVP1 v-if="user.core_role_id < 11 && user.core_role_id > 0"/>
    <!-- end -->
    <!-- #page-onboarding -->
  </div>
</template>
<script>
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import OnboardingVP1 from "../../components/onboarding/onboardingVP1.vue";
import OnboardingVP2 from "../../components/onboarding/onboardingVP2.vue";

export default {
  name: 'HomeOnboarding',
  components: {
    MainBarMenu,
    MainBarMenuV2,
    OnboardingVP1,
    OnboardingVP2,
  }
}
</script>
<style lang="scss">
</style>